import React from 'react'
import { Typography, Box,  Grid, Dialog, DialogContent, useMediaQuery} from '@mui/material';
import { CalendarPicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import CloseModalIcon from '../../../icons/RoundCloseIcon.svg'

interface SelectDateModalProps {
    open: boolean;
    onClose: () => void;
    onChangeDate:(e: Date | null)=>void;
    date: Date | null;
    isInvisible: boolean;
    minDate?:Date | undefined; //optional: minimum date that should appear on the calendar
}

const SelectDateModal = (props: SelectDateModalProps) => {
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const style = {
        height: isOnMobileScreen ? '' : '555px'
    };
    return (
        <React.Fragment>
            <Dialog
                open={props.open}
                onClose={() => {
                    props.onClose()
                }}
                fullScreen={isOnMobileScreen}
                BackdropProps={{
                    invisible: props.isInvisible
                }}
                fullWidth={true}
                disableEnforceFocus
                style={{
                    background: "none",
                }}
                PaperProps={{
                    style: {
                        pointerEvents: "auto",
                        width: '520px',
                        boxShadow: 'none',
                        borderRadius: '24px'
                    },
                }}
                disableEscapeKeyDown={true}
            >
                <DialogContent>
                    <Box
                        sx={style}
                    >
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={2}> </Grid>
                            <Grid item xs={8}>
                                <Typography
                                    align='center'
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: "18px",
                                        lineHeight: "22px",
                                        fontFamily: "Work Sans",
                                    }}>
                                    Due Date
                                </Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <img src={CloseModalIcon} alt="close" style={{ cursor: 'pointer', marginLeft: isOnMobileScreen ? "0px" : "40px" }} onClick={() => {
                                    props.onClose()
                                }} />
                            </Grid>
                            <Grid item xs={12} sx={{height:'400px'}}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <CalendarPicker
                                        onChange={props.onChangeDate}
                                        date={props.date}
                                        minDate={props.minDate || new Date()}
                                        disableHighlightToday

                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default SelectDateModal;
